module.exports = __webpack_public_path__ + "img/logo-open-images-browser.256ea29f.png";